const zhCN = {
  'Welcome to React': '欢迎来到React',
  '404subTitle': '抱歉，您访问的页面不存在。',
  '403subTitle': '抱歉，您无权访问此页面。',
  '500subTitle': '抱歉，出了问题。',
  'Back Home': '返回首页',
  'Loading': '加载中 ...',

  // 登录页
  'Please input your Username!': '请输入您的用户名！',
  'Username': '用户名',
  'Please input your Password!': '请输入您的密码！',
  'Password': '密码',
  'Confirm Password': '确认密码',
  'Please confirm your password!': '请再次输入您的密码！',
  'The two passwords that you entered do not match!': '您输入的两个密码不匹配！',
  'Remember me': '记住密码',
  'Forgot password': '忘记密码',
  'Log in': '登录',
  'Or': '或',
  'Login!': '登录！',
  'register now!': '注册！',
  'Password Login': '密码登录',
  'Verification login': '验证码登录',
  'Phone': '手机号',
  'Please input your Phone!': '请输入您的手机号！',
  'Incorrect mobile number format!': '手机号格式有误！',
  'Verification': '验证码',
  'Please input your Verification!': '请输入您的验证码！',
  'Incorrect format of verification number!': '验证码格式有误！',
  'Get verification code': '获取验证码',
  'E-mail': '邮箱',
  'The input is not valid E-mail!': '输入的邮箱无效！',
  'Please input your E-mail!': '请输入您的邮箱！',
  'Should accept agreement': '请阅读并接受协议',
  'I have read the': '我已经阅读了',
  'agreement': '协议',
  'Register': '注册',
  '登陆成功': '登陆成功',
  'Verification code verification': '验证码验证',
  'Reset password': '重置密码',
  'Next step': '下一步',
}

export default zhCN